import { render } from "./RecentAppointments.vue?vue&type=template&id=0f951217&scoped=true&ts=true"
import script from "./RecentAppointments.vue?vue&type=script&lang=ts"
export * from "./RecentAppointments.vue?vue&type=script&lang=ts"

import "./RecentAppointments.vue?vue&type=style&index=0&id=0f951217&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f951217"]])

export default __exports__